import React from 'react';
import { FuelSkeleton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import * as StyledModal from '../../ModalMonitoringStyles';
import * as Styled from './SkeletonStyles';

function Skeleton() {
  function collumn() {
    return (
      <Styled.Collumn>
        <div>
          <FuelSkeleton shape="pill" size="custom" width="57px" height="13px" />
        </div>
        <div>
          <FuelSkeleton
            shape="pill"
            size="custom"
            width="103px"
            height="17px"
          />
        </div>
      </Styled.Collumn>
    );
  }

  return (
    <>
      <StyledModal.Section hasDivider data-testid="skeleton-details">
        <FuelSkeleton shape="pill" size="custom" width="150px" height="14px" />
        {Array.from({ length: 2 }, (_, index) => (
          <FuelFlex key={`skeleton-monitoring-details-${index}`}>
            {collumn()}
            {collumn()}
          </FuelFlex>
        ))}
      </StyledModal.Section>
      <StyledModal.Section hasDivider>
        <FuelSkeleton shape="pill" size="custom" width="150px" height="14px" />
        <FuelFlex>
          {collumn()}
          {collumn()}
          {collumn()}
        </FuelFlex>
      </StyledModal.Section>
    </>
  );
}

export default Skeleton;
